var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 31.5,
    height: 19.5,
    rx: 1.75,
    fill: "#1F72CD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 31.5,
    height: 19.5,
    rx: 1.75,
    stroke: "black",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6923 6.97668L3.979 13.0157H7.2272L7.62988 12.0528H8.55033L8.95301 13.0157H12.5284V12.2808L12.847 13.0157H14.6964L15.015 12.2652V13.0157H22.4508L23.3549 12.0778L24.2015 13.0157L28.0207 13.0234L25.2988 10.013L28.0207 6.97668H24.2608L23.3806 7.89721L22.5607 6.97668H14.4715L13.7769 8.53539L13.066 6.97668H9.82458V7.68656L9.46399 6.97668H6.6923ZM7.3208 7.83425H8.90413L10.7039 11.9293V7.83425H12.4383L13.8284 10.7704L15.1095 7.83425H16.8353V12.1676H15.7852L15.7767 8.77201L14.2457 12.1676H13.3063L11.7668 8.77201V12.1676H9.60647L9.19691 11.1961H6.98423L6.57552 12.1668H5.41805L7.3208 7.83425ZM22.0662 7.83425H17.7962V12.1651H22L23.355 10.7298L24.661 12.1651H26.0262L24.0419 10.0122L26.0262 7.83425H24.7202L23.3721 9.25306L22.0662 7.83425ZM8.09111 8.56743L7.36212 10.2981H8.81925L8.09111 8.56743ZM18.8506 9.52251V8.73146L21.5149 8.7307L22.6775 9.99577L21.4634 11.2678H18.8506V10.4042H21.18V9.52251H18.8506Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.a251221143d6912086f8d24ad5423a46.svg";
export { ForwardRef as ReactComponent };